import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDotCircle, faUpDownLeftRight, faX } from '@fortawesome/free-solid-svg-icons';

//STYLES
import { Box } from '../../../../../../../../../../../../../../../../../Components/CustomUi/box';

//APP
import { HeaderInfo } from './styled';

//COMPONENTS
import ButtonCustom from '../../../../../../../../../../../../../../../../../Components/ButtonCustom';
import { GridMalha } from '../../gerarMalha';

interface PropsPontos {
    novoPonto: boolean
    setNovoPonto: React.Dispatch<React.SetStateAction<boolean>>
    moverPonto: boolean
    setMoverPonto: React.Dispatch<React.SetStateAction<boolean>>
    removerPonto: boolean
    setRemoverPonto: React.Dispatch<React.SetStateAction<boolean>>
    area: number
    grid: GridMalha[]
    quadrante: number
}

export const AbaPontos: React.FC<PropsPontos> = React.memo(({
    novoPonto,
    setNovoPonto,
    moverPonto,
    setMoverPonto,
    removerPonto,
    setRemoverPonto,
    area,
    grid,
    quadrante
}) => {
    const [totalPontos, setTotalPontos] = useState(0)
    const [valorGrid, setValorGrid] = useState(0)

    function opcoesPontos(opcao: string) {
        if (opcao === 'novo') {
            setNovoPonto(true)
            setMoverPonto(false)
            setRemoverPonto(false)
        }

        if (opcao === 'mover') {
            setMoverPonto(true)
            setNovoPonto(false)
            setRemoverPonto(false)
        }

        if (opcao === 'remover') {
            setRemoverPonto(true)
            setNovoPonto(false)
            setMoverPonto(false)
        }
    }

    useEffect(() => {
        const pontosFiltrados = grid.filter((item) => item.oculto === false)
        const gridValor = area / pontosFiltrados.length
        setTotalPontos(pontosFiltrados.length)
        setValorGrid(gridValor)
    }, [grid])


    return (
        <>
            <HeaderInfo>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <div>
                        <label>Área:</label>
                        <p style={{ margin: 0, padding: 0 }}>{`${area} ha`}</p>
                    </div>
                    <div>
                        <label>Pontos:</label>
                        <p style={{ margin: 0, padding: 0 }}>{totalPontos}</p>
                    </div>
                </div>
                <div>
                    <label>Grid:</label>
                    <p style={{ margin: 0, padding: 0 }}>{`${valorGrid.toFixed(2)} ha por ponto `}</p>
                </div>
            </HeaderInfo>

            <Box>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <ButtonCustom
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '30%',
                            height: '70px',
                            fontSize: '12px',
                            backgroundColor: novoPonto ? '#5DA57D' : 'white',
                            color: novoPonto ? 'white' : '#5DA57D',
                        }}
                        type='secondary'
                        onClick={() => opcoesPontos('novo')}
                        icon={<FontAwesomeIcon fontSize={15} icon={faDotCircle} />}
                    >
                        Novo
                    </ButtonCustom>
                    <ButtonCustom
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '30%',
                            height: '70px',
                            fontSize: '12px',
                            backgroundColor: moverPonto ? '#5DA57D' : 'white',
                            color: moverPonto ? 'white' : '#5DA57D',
                        }}
                        type='secondary'
                        onClick={() => opcoesPontos('mover')}
                        icon={<FontAwesomeIcon fontSize={18} icon={faUpDownLeftRight} />}
                    >
                        Mover
                    </ButtonCustom>
                    <ButtonCustom
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '30%',
                            height: '70px',
                            fontSize: '12px',
                            backgroundColor: removerPonto ? 'red' : 'white',
                            color: removerPonto ? 'white' : 'red',
                        }}
                        type='secondary'
                        danger
                        onClick={() => opcoesPontos('remover')}
                        icon={<FontAwesomeIcon fontSize={15} icon={faX} />}
                    >
                        Remover
                    </ButtonCustom>
                </div>
            </Box>
        </>
    )
})